module.exports = __webpack_public_path__ + "static/media/SummaryCh10_A01378565.309b7bce.pdf";